import API from '@/services/api'

export const FETCH_ONLINE_PROJECT_DOSSIER = 'fetchOnlineProjectDossier'

// Mutations
export const STORE_SET_ONLINE_PROJECT_DOSSIER = 'storeSetOnlineProjectDossier'

const state = {
	onlineProjectDossier: {
		id: null,
		name: null,
		file_id: null,
		start_date: null,
		description: null,
		activities: '',
		created_at: null,
		author: {},
		company: {
			users: []
		},
		properties: [],
		inspectors: [],
		inspectionDates: [],
		reports: [],
		images: []
	},
}

const getters = {
	onlineProjectDossier (state) {
		return state.onlineProjectDossier
	},
}

const actions = {
	[FETCH_ONLINE_PROJECT_DOSSIER] (context, id) {
		return new Promise((resolve, reject) => {
			API.query('online-dossier/project/' + id).then((response) => {
				context.commit(STORE_SET_ONLINE_PROJECT_DOSSIER, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_ONLINE_PROJECT_DOSSIER] (state, dossier) {
		state.onlineProjectDossier = dossier
	},
}

export default {
	state,
	actions,
	mutations,
	getters,
}